<template>
  <div class="my-2 border-t border-white/10" />
</template>
